function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("ellipse", {
  cx: 10.5,
  cy: 11,
  fill: "#2BCDC0",
  rx: 10.5,
  ry: 11
}), React.createElement("g", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(5 7)"
}, React.createElement("path", {
  d: "M3.66748148 8L11 0M3.66707407 8L0 4"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    style: {
      "height": "1em",
      "width": "0.95455em"
    },
    className: "icon"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/check-round.3557ad1a.svg";
export { SvgComponent as ReactComponent };